import { Pipe, PipeTransform } from '@angular/core';
import { SessionHelper } from '../../../shared/services/localstorage';
import { roleID } from '../../../configurations/configuration';

@Pipe({
  name: 'initialLetter'
})
export class InitialLetterPipe implements PipeTransform {
  roleID = roleID;
  user: any = {};
  speaker: string;
  transform(value: any, args?: any): any {
    if(value=='' || value==null)
    return value;

    console.log(value, args);
    this.speaker = value;
    this.user = SessionHelper.getSession();
      if(value && this.user.role_id === this.roleID.SALES_REP_ROLE_ID || this.user.role_id === this.roleID.MARKETING_ROLE_ID) {
        let splitname = value.split(" ");
        value = '';
        console.log("split", splitname);
        // value = splitname[0] + ' ' + splitname[splitname.length - 1].charAt(0);
        splitname.forEach((element, index) => {
          if(index != splitname.length - 1) {
            value += element + ' ';
          }
          else if(index == splitname.length - 1) {
            value += element.charAt(0) + '.';
          }
        });
      }
      else {
        value = this.speaker;
      }
    return value;
  }

}
